// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3C93E","colBig":"styles_colBig__3Y7lX","colSmall":"styles_colSmall__2ofZ9"};